
import { MouseEvent, ChangeEvent, useEffect, useRef, useState } from "react";
//--------------------------------------------------------------------------------------------
import { useUploadImageStore } from "../main/imageStore";
import { Form, useRouteLoaderData } from "react-router-dom";

import { Link } from "react-router-dom";
import { emptyPost, Post, PostPhoto } from "./types";
//--------------------------------------------------------------------------------------------
const apiMap = {"Edit": "community/updatePost.php", "Add": "community/createPost.php"}
export default function PostForm({ keyword }: {keyword: keyof typeof apiMap}){
    const url = apiMap[keyword];
    const post = (useRouteLoaderData("post") as Post | undefined) ?? emptyPost;
    const { images, addImages, removeImage, reset } = useUploadImageStore();
    const [currentPhotos, setCurrentPhotos] = useState<PostPhoto[]>(post.photos ?? []);
    const onSelect = (e:ChangeEvent<HTMLInputElement>) => {
        const files = e.currentTarget.files;
        if (!files) return;
        const filesArr = Array.from(files);
        addImages(filesArr);
        e.currentTarget.value = "";
    };
    const inputRef = useRef<HTMLInputElement | null>(null);
    useEffect(() => {
        reset();
        if(inputRef.current){
            const input = inputRef.current;
            input.focus();
            input.setSelectionRange(input.value.length, input.value.length);
        }
        return () => {
            reset();
        };
    }, [reset]);
    if(!url) return <></>;
    //--------------------------------------------------------------------------------------------
    return(
        <Form method = "post">
            <div>
                <input type = "hidden" name = "id" value = {post.id}/>
                <input type = "hidden" name = "url" value = {apiMap[keyword]}/>
                <input type = "hidden" name = "originalPhotoIds" value = {JSON.stringify((post.photos ?? []).map(photo => photo.id))}/>
                <input type = "hidden" name = "currentPhotoIds" value = {JSON.stringify(currentPhotos.map(photo => photo.id))}/>
                <div className = "my-2" style = {{display:"flex"}}>
                    <span className = "fw-bold me-3">
                        Subject:
                    </span>
                    <input
                        ref = {inputRef}
                        type = "text"
                        required
                        className = "form-control"
                        style = {{flexGrow: 1}}
                        name = "subject"
                        defaultValue = {post.subject}
                    />
                </div>
                <div className = "my-2" style = {{display:"flex"}}>
                    <span className = "fw-bold me-3">
                        Body:
                    </span>
                    <textarea required className = "form-control" style = {{flexGrow: 1}} name = "body" defaultValue = {post.body}/>
                </div>
                <span className = "btn btn-primary" onClick = {(e:MouseEvent<HTMLSpanElement>) => {(e.currentTarget.nextElementSibling as HTMLInputElement).click()}}>
                    Upload New Photos
                </span>
                <input className = "nodisplay" type = "file" multiple accept = "image/*" onChange = {onSelect} />
                <div style = {{ display: "flex", flexWrap: "wrap", marginTop: 10, marginBottom: 10 }}>
                    {currentPhotos.map((photo, imgIndex) => (
                    <div key = {photo.id || imgIndex} style = {{ marginRight: 10, position: "relative" }}>
                        <img
                            alt = ""
                            src = {photo.url}
                            style = {{ width: 120, height: 120, objectFit: "cover" }}
                        />
                        <button
                            type = "button"
                            onClick = {() => setCurrentPhotos(photos => photos.filter(eachPhoto => eachPhoto.id !== photo.id))}
                            style = {{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                background: "black",
                                color: "white",
                            }}
                        >
                        X
                        </button>
                    </div>
                    ))}
                    {images.map((image, imgIndex) => (
                    <div key = {imgIndex} style = {{ marginRight: 10, position: "relative" }}>
                        <img
                            alt = ""
                            src = {image.preview}
                            style = {{ width: 120, height: 120, objectFit: "cover" }}
                        />
                        <button
                            type = "button"
                            onClick = {() => removeImage(imgIndex)}
                            style = {{
                                position: "absolute",
                                right: 0,
                                top: 0,
                                background: "black",
                                color: "white",
                            }}
                        >
                        X
                        </button>
                    </div>
                    ))}
                </div>
            </div>
            <div className = "mb-3">
                <Link children = "Close" to = ".." className = "btn btn-secondary me-3"/>
                <button children = {keyword} type = "submit" className = "btn btn-primary float-end"/>
            </div>
        </Form>
    )
}
